/****************************************************************
 * File: home.service.ts
 * Description:
 * Author: zayfen <zhangyunfeng@pudutech.com>
 * Created: 2022/06/13 16:46
 *
 * History:
 *   Date               Programmer ID    Description
 *  -----------------  ---------------  ------------------------
 *  2022/06/13 16:46   zayfen           Init
 *
 * This unpublished material is proprietary to PuduTech.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of PuduTech.
 *****************************************************************/

import { findRegionByLocale } from '../common/region-locale'
import type { MediaAlt } from '../common/media-alt'
import { requestV2 } from './request'

type Banner = {
  mediaUrl: string
  mediaUrlH5: string
  jumpUrl: string
  title: string
  desc: string
  fontColor: string
  needAuto: boolean
  titleMediaUrl: string
  alts: MediaAlt[] | null
  altsH5: MediaAlt[] | null
  titleMediaAlts: MediaAlt[] | null
}

type Ads = {
  id: number
  mediaUrl: string
  jumpUrl: string
  title: string
  desc: string
  code: string
  type: string
}

type Solution = {
  mediaUrl: string
  alts: MediaAlt[] | null
  title: string
  jumpUrl: string
  desc: string
}

type Customer = {
  jumpUrl: string
  mediaUrl: string
  alts: MediaAlt[] | null
  title: string
}

type Card = {
  mediaUrl: string
  alts: MediaAlt[] | null
  title: string
  secondTitle: string
  content: string
}

type News = {
  docPath: string
  jumpUrl: string
  mediaUrl: string
  alts: MediaAlt[] | null
  title: string
  content: string
  date: string
  type?: 'news' | 'media' | 'blog' | 'event'
}

type Message = {
  title: string
  content: string
  mediaUrl: string
  alts: MediaAlt[] | null
  item: Array<{
    name: string
    desc: string
  }>
}

type HomeProductLines = {
  title: string
  mediaUrl: string
  mediaH5Url: string
  alts: MediaAlt[] | null
  altsH5: MediaAlt[] | null
  jumpUrl: string
  fontColor: string
}

type ProductLine = {
  title: string
  items: { mediaUrl: string; jumpUrl: string; title: string; desc: string }[]
}

export type HomeData = {
  banner: Array<Banner>
  productLine: ProductLine[]
  homeProductLines: HomeProductLines[]
  solutions: Array<Solution>
  customers: Array<Customer>
  customerLogos: Array<string>
  cards: Array<Card>
  messages: Message
  topNews: Array<News>
  news: Array<News>
  homeNews: News
  solutionTitle: string // 解决方案标题
  customerTitle: string // 客户案例标题
  cardTitle: string // 用户卡片标题
  logoTitle: string // 客户logo标题
  newsTitle: string // 新闻标题
  // leftAds: Ads
  // rightAds: Ads
  // agentItems: {
  //   address: string
  //   email: string
  //   logoUrl: string
  //   tagName: string
  //   title: string
  //   website: string
  //   contactInfo: string
  //   telephone: string
  // }[]
}

export async function getHomePageData(locale: string): Promise<HomeData> {
  const res = await requestV2('/home', { region: findRegionByLocale(locale) })
  return res
}
